export default __webpack_public_path__ + "static/media/pop_window.981c9858.mp3";